module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAABHNCSVQICAgIfAhkiAAAARtJREFUKFOVksFVwkAQhuffcPEkVgAlwI2Vt0o60AqIHdCBsQM6UCvQDtyXvBc4xg4oAS54Ifl9AZMQEyTuad/MfDOz/7+QEycNtRVKDw7uMY7ipjI0BRmMPEI9H3K0yizc1nAa6pUIejkASV2Ypf3doDY5Ca99iDxWC2nR4QP0cnUcBwN9R8hUKAMB+qc0KOO0EFiY6AlpoNcCXJ6HqhVQMsReVcHtv2Byg+SrD34MuuxcvLdukIEOJpl9hWBJoF8ATM9s8AklXu57AR+Ew9tfMMlX52bhlRb+3JotqrWKlYmGNbitcMpExbbFpQKTGwJzRcaEzI7FxG57BTdeZ9PLN4ejCQU+BVbttvO8YP+7sxzVjJDYMZGfr/0N3v5yO3q3jEMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/allSubject/choiceCollect.png
// module id = /ZgN
// module chunks = 3